import React, {Component} from 'react';
import {connect} from 'react-redux';
import {translate} from 'react-i18next';
import {bindActionCreators} from 'redux';
import * as languageActions from "../actions/languageActions";
import * as _ from 'lodash';
import {DEFAULT_LANGUAGE, LANGUAGES} from '../constants';
import {getUriWithLanguages} from '../helpers';


class LanguageURLComponent extends Component{

    componentDidMount() {
      let lng = this.props.match.params.lng || this.props.match.params[0];
      const {defaultLanguage} = this.props.language;
      const {i18n} = this.props;
      if (!_.isUndefined(lng) && lng !== defaultLanguage) {
        if (!_.includes(Object.keys(LANGUAGES), lng)) {
          lng = DEFAULT_LANGUAGE;
        }
        i18n.changeLanguage(lng);
        this.props.setLanguage(lng);
      }

      this.props.history.listen((location, action) => {
        const lng = this.props.language.defaultLanguage;
        if (action === 'POP' && !_.isUndefined(lng)) {
          const newPath = getUriWithLanguages(location.pathname, lng, this.props.restaurants);
          this.props.history.replace(decodeURIComponent(newPath));
        }
      });
    }

    render(){
      return (
        <React.Fragment>
        </React.Fragment>
      );
    }
  }

function mapStateToProps(state) {
  return {
    language: state.language,
    restaurants: state.restaurants.list
  }
}

function mapDispatchToProps(dispatch) {
  return {
    setLanguage: bindActionCreators(languageActions.setLanguage, dispatch),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(translate('translations')(LanguageURLComponent));


// WEBPACK FOOTER //
// ./src/containers/withlangaugeURL.js